<div class="address_body">
    <h3>
      Change address
    </h3>
    <p>
      Location where protection is needed?
    </p>
    <span (click)="close()" class="close">
      <img src="https://cdn.elitehw.com/images/cross.webp" />
    </span>
  
    <div class="formarea">
      <form [formGroup]="addressForm">
        <div class="input_section">
          <div class="inputprt">
            <span class="address">
              <input type="text" placeholder="Address" formControlName="address" (keyup)="apiService.changeInput(address, true)"
              #address />
            </span>
            
              <span class="unit">
                <input type="text" placeholder="Unit Number" formControlName="unitNumber" />
              </span>
          </div>
          <mat-error *ngIf="
                    addressForm.controls['address'].touched &&
                    addressForm.controls['address'].hasError('required')
                  ">
              This is required
            </mat-error>
            <mat-error *ngIf="addressForm.controls['address'].hasError('notValid')">
              Invalid zipcode.
            </mat-error>
            <mat-error *ngIf="addressForm.controls['address']?.errors?.notCovered">
              Unfortunately, we do not cover the state of {{addressForm.value?.state}}.
            </mat-error>
        </div>
        
        <span *ngIf="showZipCodeField">
          <input type="text" placeholder="Zip code" formControlName="zip" mask="00000" (keyup)="checkZipCode()" />
          <mat-error *ngIf="
                addressForm.controls['zip'].touched &&
                addressForm.controls['zip'].hasError('required')
              ">
            This is required
          </mat-error>
          <mat-error *ngIf="
                addressForm.controls['zip'].touched &&
                addressForm.controls['zip'].hasError('mask')">
           Please enter valid zip code.
          </mat-error>
          <mat-error *ngIf="
                addressForm.controls['zip'].touched &&
                addressForm.controls['zip'].hasError('notValid')">
            This zip code is not valid.
          </mat-error>
        </span>
        
        <div class="button_area">
          <button (click)="close()" class="cancel">
            Cancel
          </button>
          <button class="updatebtn" (click)="updateAddress()">
            Update
          </button>
        </div>
      </form>
    </div>
  </div>